import { calculate, getPaymentData } from './chances.js';

const API = new function () {
   this.calculate = calculate;
   this.getPaymentData = getPaymentData;
}();

export default API;